module.exports = __webpack_public_path__ + "static/media/House_Of_Commons_882x496_Colour.3ea7e68f.png";